/**
 * Canonical per-pair colors, shared by every visualization that draws a pair
 * (open-orders grid, pair analysis chart). Keeping one map means a pair keeps
 * the same color everywhere in the dashboard.
 */
const PAIR_COLORS = {
    AUDNZD: '#2563eb', // blue
    EURCAD: '#dc2626', // red
    EURUSD: '#16a34a', // green
    GBPUSD: '#9333ea', // purple
    NZDUSD: '#ea580c', // orange
    USDJPY: '#0891b2', // cyan
    CADCHF: '#db2777', // pink
    EURGBP: '#ca8a04', // yellow
    GBPJPY: '#4f46e5', // indigo
    GBPNZD: '#059669', // emerald
    NZDCAD: '#e11d48', // rose
    USDCAD: '#7c3aed', // violet
    USDCHF: '#0d9488', // teal
};
const FALLBACK_COLORS = [
    '#6366f1', '#f59e0b', '#84cc16', '#f43f5e', '#06b6d4',
    '#a855f7', '#10b981', '#ef4444', '#3b82f6', '#ec4899',
];
/**
 * Fold a broker symbol to its canonical pair. The same pair arrives in several
 * spellings depending on the feed ("eurusd", "eurusd.pro", "EURUSD.PRO"), so
 * case and any broker suffix after the pair name are both stripped.
 */
export const normalizePairSymbol = (symbol) => symbol.trim().toUpperCase().split('.')[0];
export const getPairColor = (symbol) => {
    const cleanSymbol = normalizePairSymbol(symbol);
    if (PAIR_COLORS[cleanSymbol]) {
        return PAIR_COLORS[cleanSymbol];
    }
    let hash = 0;
    for (let i = 0; i < cleanSymbol.length; i++) {
        hash = cleanSymbol.charCodeAt(i) + ((hash << 5) - hash);
    }
    return FALLBACK_COLORS[Math.abs(hash) % FALLBACK_COLORS.length];
};
